<template>
  <div class="MedicenCata">
    <!-- main -->
    <div class="main">
      <!-- right -->
      <div class="main-right">
        <!-- tit -->
        <div class="main-icon">
          <div class="main-icon-a">
            <i :class="iconComes"
               style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #5a5a5a;color: #fff;"></i>
            <span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">{{ CatalogueName }}</span>
          </div>
          <!-- btn1 -->
          <div class="main-icon-b">
            <span style="font-size: 12px;color: #606266;font-weight: bold;">状态：</span>
            <el-dropdown @command="handleCommand" trigger="click">
    <span class="el-dropdown-link" style="font-size: 12px;color: #606266;font-weight: bold;">
      {{ DropDownedName }}<i class="el-icon-down"></i>
    </span>
              <el-dropdown-menu slot="dropdown" class="status-dropdown">
                <el-dropdown-item command="a">可用</el-dropdown-item>
                <el-dropdown-item command="b">禁用</el-dropdown-item>
                <el-dropdown-item command="c" divided>全部</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- 按钮栏 -->
          <div class="main-icon-c">
            <span style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">关键字：</span>
            <el-input size="mini" placeholder="输入名称进行搜索" v-model="searchValue" @keyup.enter.native="handClick(0)"></el-input>
          </div>
          <!-- 按钮栏 -->
          <div class="main-icon-c">
            <el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini"
                       v-if="!v.auth || $store.getters.hasPermission(v.auth)"
                       @click="handClick(i)">{{ v.title }}
            </el-button>
          </div>
        </div>
        <!-- table -->
        <div class="table">
          <el-table :data="tableData" border @row-dblclick="handledbRow">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type"
                             :prop="col.prop" :label="col.name" align="center"
                             :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width='158' v-if="$store.getters.hasPermission('system:registertype:edit')">
              <template slot-scope="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleClickEdit(scope.row)" size="mini">编辑</el-button>
                  <el-button :type="scope.row.status === '1' ? 'danger' : 'success'"
                             @click="handleStartOrDisabled(scope.row)" size="mini">
                    {{ scope.row.status === '1' ? '禁用' : '启用' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <el-pagination
            class="fixed-pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[8, 16, 24]"
            :page-size="pageSize"
            :total="totalSize"
            layout="total, sizes, prev, pager, next, jumper"
            background>
        </el-pagination>
      </div>
    </div>

    <!-- 新增挂号类别表单 -->
    <el-dialog title="新增挂号类别" :visible.sync="addDialogVisible" width="50%" :before-close="handleClose"
               :close-on-click-modal="false" class="compact-form">
      <el-form :model="addForm" label-width="85px" size="mini" :rules="formRules" ref="addFormRef">
        <el-row :gutter="20">
          <!-- 名称 -->
          <el-col :span="8">
            <el-form-item prop="designation" label="名称:">
              <el-input v-model="addForm.designation" placeholder="请输入名称" @input="handleNameInput"></el-input>
            </el-form-item>
          </el-col>

          <!-- 有效状态 -->
          <el-col :span="8">
            <el-form-item prop="status" label="有效状态:">
              <el-select v-model="addForm.status" placeholder="请选择">
                <el-option v-for="item in statusOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 拼音简码 -->
          <el-col :span="7">
            <el-form-item label="拼音简码:">
              <el-input v-model="addForm.pycode" disabled></el-input>
            </el-form-item>
          </el-col>

          <!-- 使用时间 -->
          <el-col :span="8">
            <el-form-item prop="timeRange" label="使用时间:" class="compact-time-pickers">
              <el-time-picker v-model="timeRange" is-range range-separator="-" start-placeholder="开始时间"
                              end-placeholder="结束时间" format="HH:mm:ss" value-format="HH:mm:ss" size="mini"
                              :picker-options="{selectableRange: '00:00:00 - 23:59:59'}"
                              @change="handleTimeRangeChange" style="width: 100%">
              </el-time-picker>
            </el-form-item>
          </el-col>

          <!-- 年龄下限 -->
          <el-col :span="8">
            <el-form-item label="年龄下限:">
              <el-input-number v-model="addForm.startage" :min="0" :max="200" controls-position="right" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>

          <!-- 年龄上限 -->
          <el-col :span="8">
            <el-form-item label="年龄上限:">
              <el-input-number v-model="addForm.endage" :min="0" :max="200" controls-position="right" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>

          <!-- 挂号类型 -->
          <el-col :span="8">
            <el-form-item prop="registertype" label="挂号类型:">
              <el-select v-model="addForm.registertype" placeholder="请选择">
                <el-option v-for="item in TypeOption" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 备注说明 -->
          <el-col :span="20">
            <el-form-item label="备注说明:">
              <el-input type="textarea" v-model="addForm.remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 职称设置 -->
        <div class="multi-select-container">
          <div class="select-row">
            <span class="select-label" style="margin-left: -10px">职称设置:</span>
            <div class="select-with-tags">
              <el-select v-model="selectedValues" multiple filterable placeholder="请选择职称" @focus="handleSelectionChange" size="mini">
                <el-option v-for="item in profttlIds" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
              <div class="selected-tags" v-if="selectedValues.length > 0">
                <el-tag v-for="(value, index) in selectedValues" :key="index" closable @close="removeItem(index)" type="info" size="mini">
                  {{ getLabelById(value) }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>

        <!-- 对应费用 -->
        <div class="table-header">
          <span>对应费用:</span>
          <el-button-group class="transparent-btn-group">
            <el-button icon="el-icon-plus" size="mini" class="transparent-btn" @click="addPriceDialogVisible = true"></el-button>
            <el-button icon="el-icon-edit" size="mini" class="transparent-btn" :disabled="!selectedRow" @click="handlePriceEdit"></el-button>
            <el-button icon="el-icon-circle-close" size="mini" class="transparent-btn" :disabled="!selectedRow" @click="handlePriceDelete"></el-button>
          </el-button-group>
        </div>
        <el-table :data="tableData2" border @row-click="handleRowClick" highlight-current-row ref="myTable">
          <template v-for="col in tableRows2">
            <el-table-column :key="col.prop" :type="col.type" :prop="col.prop" :label="col.name"
                             :formatter="(row) => formatColumn(row, col.prop)" align="center"></el-table-column>
          </template>
          <el-table-column fixed="left" label="行号" type="index" width="50"></el-table-column>
        </el-table>

        <div style="margin-top: 10px; text-align: right; font-weight: bold;">
          合计: {{ calculateTotal() }}元
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="addCategoryData">确定</el-button>
        <el-button size="mini" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <!-- 修改挂号类别表单 -->
    <el-dialog :title="dynamicTitle" :visible.sync="editDialogVisible" width="50%" :before-close="handleClose"
               :close-on-click-modal="false" class="compact-form">
      <el-form :model="editForm" label-width="85px" size="mini" :rules="formRules" ref="editFormRef"
               :disabled="isLookData">
        <el-row :gutter="20">
          <!-- 名称 -->
          <el-col :span="8">
            <el-form-item prop="designation" label="名称:">
              <el-input v-model="editForm.designation" placeholder="请输入名称" @input="handleNameInputForEdit"></el-input>
            </el-form-item>
          </el-col>

          <!-- 有效状态 -->
          <el-col :span="8">
            <el-form-item prop="status" label="有效状态:">
              <el-select v-model="editForm.status" placeholder="请选择">
                <el-option v-for="item in statusOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 拼音简码 -->
          <el-col :span="7">
            <el-form-item label="拼音简码:">
              <el-input v-model="editForm.pycode" disabled></el-input>
            </el-form-item>
          </el-col>

          <!-- 使用时间 -->
          <el-col :span="8">
            <el-form-item prop="timeRange" label="使用时间:" class="compact-time-pickers">
              <el-time-picker v-model="editTimeRange" is-range range-separator="-" start-placeholder="开始时间"
                              end-placeholder="结束时间" format="HH:mm:ss" value-format="HH:mm:ss" size="mini"
                              :picker-options="{selectableRange: '00:00:00 - 23:59:59'}"
                              @change="handleTimeRangeChange2" style="width: 100%">
              </el-time-picker>
            </el-form-item>
          </el-col>

          <!-- 年龄下限 -->
          <el-col :span="8">
            <el-form-item label="年龄下限:">
              <el-input-number v-model="editForm.startage" :min="0" :max="200" controls-position="right" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>

          <!-- 年龄上限 -->
          <el-col :span="8">
            <el-form-item label="年龄上限:">
              <el-input-number v-model="editForm.endage" :min="0" :max="200" controls-position="right" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>

          <!-- 挂号类型 -->
          <el-col :span="8">
            <el-form-item prop="registertype" label="挂号类型:">
              <el-select v-model="editForm.registertype" placeholder="请选择">
                <el-option v-for="item in TypeOption" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 备注说明 -->
          <el-col :span="20">
            <el-form-item label="备注说明:">
              <el-input type="textarea" v-model="editForm.remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 职称设置 -->
        <div class="multi-select-container">
          <div class="select-row">
            <span class="select-label" style="margin-left: -10px">职称设置:</span>
            <div class="select-with-tags">
              <el-select v-model="selectedValues" multiple filterable placeholder="请选择职称" @focus="handleSelectionChange" size="mini">
                <el-option v-for="item in profttlIds" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
              <div class="selected-tags" v-if="selectedValues.length > 0">
                <el-tag v-for="(value, index) in selectedValues" :key="index" closable @close="removeItem(index)" type="info" size="mini">
                  {{ getLabelById(value) }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>

        <!-- 对应费用 -->
        <div class="table-header">
          <span>对应费用:</span>
          <el-button-group class="transparent-btn-group">
            <el-button icon="el-icon-plus" size="mini" class="transparent-btn" @click="addPriceDialogVisible = true"></el-button>
            <el-button icon="el-icon-edit" size="mini" class="transparent-btn" :disabled="!selectedRow" @click="handlePriceEdit"></el-button>
            <el-button icon="el-icon-circle-close" size="mini" class="transparent-btn" :disabled="!selectedRow" @click="handlePriceDelete"></el-button>
          </el-button-group>
        </div>
        <el-table :data="tableData2" border @row-click="handleRowClick" highlight-current-row ref="myTable">
          <template v-for="col in tableRows2">
            <el-table-column :key="col.prop" :type="col.type" :prop="col.prop" :label="col.name"
                             :formatter="(row) => formatColumn(row, col.prop)" align="center"></el-table-column>
          </template>
          <el-table-column fixed="left" label="行号" type="index" width="50"></el-table-column>
        </el-table>

        <div style="margin-top: 10px; text-align: right; font-weight: bold;">
          合计: {{ calculateTotal() }}元
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitForm" :disabled="isLookData">修改</el-button>
        <el-button size="mini" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <!-- 对应费用-修改对话框 -->
    <el-dialog :close-on-click-modal="false" title="对应费用-修改" :visible.sync="editPriceDialogVisible" width="20%"
               :before-close="handleEditPriceClose">
      <div class="price-form-container">
        <el-form :model="editPriceForm" size="mini" class="compact-form center-form">
          <el-form-item label="项目名称:" prop="costid">
            <el-select filterable :filter-method="handleSimpleSearch" v-model="editPriceForm.costid" placeholder="请选择"
                       style="width: 180px;" @focus="loadItemPriceOptions">
              <el-option v-for="item in itemPriceOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目数量:" prop="num">
            <el-input-number :min="1" :precision="0" :controls="false" v-model.number="editPriceForm.num"
                             @change="handleEditNumChange" style="width: 180px;"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="handleEditPriceData">确定</el-button>
        <el-button size="mini" @click="handleEditPriceClose">取消</el-button>
      </span>
    </el-dialog>

    <!-- 对应费用-新增对话框 -->
    <el-dialog :close-on-click-modal="false" title="对应费用-新增" :visible.sync="addPriceDialogVisible" width="20%"
               :before-close="handleAddPriceClose">
      <div class="price-form-container">
        <el-form :model="addPriceForm" size="mini" class="compact-form center-form">
          <el-form-item label="项目名称:" prop="costid">
            <el-select filterable :filter-method="handleSimpleSearch" v-model="addPriceForm.costid" placeholder="请选择"
                       style="width: 180px;" @focus="loadItemPriceOptions">
              <el-option v-for="item in itemPriceOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目数量:" prop="num">
            <el-input-number :min="1" :precision="0" :controls="false" v-model="addPriceForm.num"
                             @change="handleNumChange" style="width: 180px;"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="handleAddPriceData">确定</el-button>
        <el-button size="mini" @click="handleAddPriceClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  docregistertype,
  getChargingPrice,
  dict,
  addCategoryData,
  getCategory,
  editCategoryData
} from "../../../api/Outpatient/category.js";
import { pinyin } from "pinyin-pro";
import dayjs from "dayjs";
import { withLoading } from "@/untils/loading";
import { getRegisterType } from "@/api/reservation/reservation";

// 工厂函数：生成空的新增表单
const getEmptyAddForm = () => ({
  designation: '',
  status: 1,
  pycode: '',
  startTime: dayjs().startOf('day').format('HH:mm:ss'),
  endTime: dayjs().endOf('day').format('HH:mm:ss'),
  endage: 200,
  startage: 0,
  registertype: null,
  remark: "",
  profttlIds: [],
  regJoinVOS: []
});

// 工厂函数：生成空的编辑表单
const getEmptyEditForm = () => ({
  id: null,
  designation: '',
  status: 1,
  pycode: '',
  starttime: '',
  endage: null,
  startage: null,
  endtime: '',
  registertype: null,
  remark: "",
  profttlVOS: [],
  costnametableVOS: [],
  profttlIds: [],
  regJoinVOS: []
});

// 工具函数：生成拼音简码
const generatePinyinCode = (name) => {
  if (!name) return "";
  return pinyin(name, {
    pattern: 'first',
    toneType: 'none',
    separator: ''
  }).toLocaleUpperCase();
};

// 工具函数：获取默认时间范围（全天）
const getDefaultTimeRange = () => [
  dayjs().startOf('day').format('HH:mm:ss'),
  dayjs().endOf('day').format('HH:mm:ss')
];

export default {
  data() {
    return {
      timeRange: getDefaultTimeRange(),
      editTimeRange: getDefaultTimeRange(),
      selectedValues: [],
      searchValue: '',
      CatalogueName: '挂号类别',
      DropDownedName: '全部',
      iconComes: 'el-icon-cflx',
      loading: false,
      addDialogVisible: false,
      editDialogVisible: false,
      addPriceDialogVisible: false,
      editPriceDialogVisible: false,
      selectedRow: null,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,
      itemPriceOptions: [],
      addPriceForm: { id: null, num: 1, odcost: null },
      editPriceForm: { id: null, num: null, odcost: null },
      addForm: getEmptyAddForm(),
      editForm: getEmptyEditForm(),
      isLookData: false,
      dynamicTitle: '',
      formRules: {
        designation: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        registertype: [{ required: true, message: '请选择挂号类型', trigger: 'change' }],
      },
      userInfo: [],
      profttlIds: [],
      statusOptions: [{ id: 1, label: '有效' }, { id: 0, label: '禁用' }],
      TypeOption: [
        { id: 1, label: '普通挂号' },
        { id: 2, label: '急诊挂号' },
        { id: 3, label: '简易门诊' },
        { id: 4, label: '免费挂号' },
        { id: 5, label: '专家挂号' }
      ],
      headerBtn: [
        { search: "search", title: "搜索", type: "success" },
        { add: "add", title: "新增", type: "warning", auth: 'system:registertype:add' },
      ],
      tableRows: [
        { name: "名称", prop: "designation", type: "" },
        { name: "挂号类别", prop: "registertype", type: "", op: "TypeOption" },
        { name: "有效状态", prop: "status", type: "", op: "statusOptions" },
        { name: "操作人", prop: "staffName", type: "" },
        { name: "合计费用", prop: "odcost", type: "" },
        { name: "操作时间", prop: "operatingTime" },
        { name: "开始时间", prop: "starttime", type: "" },
        { name: "结束时间", prop: "endtime", type: "" },
        { name: "备注", prop: "remark", type: "" },
      ],
      tableRows2: [
        { name: "项目名称", prop: "costid", type: "" },
        { name: "门诊单价", prop: "odcost", type: "" },
        { name: "数量", prop: "num", type: "" }
      ],
      tableData: [],
      tableData2: [],
      pageDataState: null, // 用于状态筛选
    };
  },

  mounted() {
    this.loadData();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
  },

  methods: {
    // 计算总费用
    calculateTotal() {
      return this.tableData2.reduce((sum, item) => {
        return sum + (Number(item.num) || 0) * (Number(item.odcost) || 0);
      }, 0).toFixed(2);
    },

    // 名称转拼音简码（通用）
    updatePycode(form, fieldName = 'designation') {
      form.pycode = generatePinyinCode(form[fieldName]);
    },

    handleNameInput() {
      this.updatePycode(this.addForm);
    },
    handleNameInputForEdit() {
      this.updatePycode(this.editForm);
    },

    // 时间范围处理（通用）
    setTimeRange(form, rangeKey, startField, endField) {
      const range = this[rangeKey];
      if (range && range.length === 2) {
        form[startField] = range[0];
        form[endField] = range[1];
      }
    },
    handleTimeRangeChange() {
      this.setTimeRange(this.addForm, 'timeRange', 'starttime', 'endtime');
    },
    handleTimeRangeChange2() {
      this.setTimeRange(this.editForm, 'editTimeRange', 'starttime', 'endtime');
    },

    // 数量验证（通用）
    validateNumber(value, min = 1) {
      return value !== null && value !== undefined && !isNaN(value) && Number.isInteger(value) && value >= min;
    },
    handleEditNumChange(value) {
      if (!this.validateNumber(value)) {
        this.$nextTick(() => { this.editPriceForm.num = 1; });
        this.$message.warning('项目数量必须是不小于1的整数');
      }
    },
    handleNumChange(value) {
      if (!this.validateNumber(value)) {
        this.$nextTick(() => { this.addPriceForm.num = 1; });
        this.$message.warning('项目数量必须是不小于1的整数');
      }
    },

    // 职称下拉框处理
    async handleSelectionChange() {
      const res = await dict();
      this.profttlIds = res.data.profttlEntities
          .filter(v => v.type === 1)
          .map(v => ({ label: v.name, id: v.id }));
    },
    getLabelById(id) {
      const item = this.profttlIds.find(option => option.id === id);
      return item ? item.label : '';
    },
    removeItem(index) {
      this.selectedValues.splice(index, 1);
    },

    // 表格行点击
    handleRowClick(row) {
      this.$refs.myTable.setCurrentRow(row);
      this.selectedRow = row;
    },

    // 项目搜索
    handleSimpleSearch(query) {
      if (!query) return;
      const lowerQuery = query.toLowerCase();
      this.itemPriceOptions = this.itemPriceOptions.filter(item => {
        return item.label.includes(query) ||
            (item.pycode && item.pycode.toLowerCase().includes(lowerQuery));
      });
    },

    // 加载项目价格选项
    async loadItemPriceOptions() {
      const res = await getChargingPrice();
      this.itemPriceOptions = res.data.map(item => ({
        id: item.id,
        label: item.costname,
        odcost: item.odcost,
        pycode: generatePinyinCode(item.costname),
      }));
    },

    // 新增费用项目
    handleAddPriceData() {
      if (!this.addPriceForm.costid) {
        this.$message.warning('请选择项目');
        return;
      }
      const isDuplicate = this.tableData2.some(item => item.costid === this.addPriceForm.costid);
      if (isDuplicate) {
        this.$message.warning('该项目已存在，请勿重复添加');
        return;
      }
      const foundItem = this.itemPriceOptions.find(item => item.id === this.addPriceForm.costid);
      if (foundItem) {
        this.addPriceForm.odcost = foundItem.odcost;
        this.tableData2.push({ ...this.addPriceForm });
      }
      this.addPriceDialogVisible = false;
      this.addPriceForm = { id: null, num: 1, odcost: null };
    },

    // 编辑费用项目
    handleEditPriceData() {
      if (!this.editPriceForm.costid) {
        this.$message.warning('请选择项目');
        return;
      }
      if (!this.validateNumber(this.editPriceForm.num)) {
        this.$message.warning('请输入有效的数量');
        return;
      }
      const foundItem = this.itemPriceOptions.find(item => item.id === this.editPriceForm.costid);
      if (foundItem) {
        this.editPriceForm.odcost = foundItem.odcost;
        const index = this.tableData2.findIndex(item => item.costid === this.selectedRow.costid);
        if (index !== -1) {
          this.$set(this.tableData2, index, { ...this.editPriceForm });
        }
      }
      this.editPriceForm = { id: null, num: 1, odcost: null };
      this.selectedRow = null;
      this.editPriceDialogVisible = false;
    },

    handlePriceEdit() {
      if (!this.selectedRow) return;
      this.editPriceForm = { ...this.selectedRow };
      this.editPriceDialogVisible = true;
    },
    handlePriceDelete() {
      if (!this.selectedRow) return;
      this.tableData2 = this.tableData2.filter(item => item.costid !== this.selectedRow.costid);
      this.selectedRow = null;
    },

    // 重置所有对话框状态
    resetDialogState() {
      this.addDialogVisible = false;
      this.editDialogVisible = false;
      this.addPriceDialogVisible = false;
      this.editPriceDialogVisible = false;
      this.timeRange = getDefaultTimeRange();
      this.editTimeRange = getDefaultTimeRange();
      this.selectedValues = [];
      this.selectedRow = null;
      this.tableData2 = [];
      this.addForm = getEmptyAddForm();
      this.editForm = getEmptyEditForm();
      this.addPriceForm = { id: null, num: 1, odcost: null };
    },

    handleClose() {
      this.resetDialogState();
      this.loadData();
    },
    handleEditPriceClose() {
      this.editPriceForm = { id: null, num: 1, odcost: null };
      this.selectedRow = null;
      this.editPriceDialogVisible = false;
    },
    handleAddPriceClose() {
      this.addPriceForm = { id: null, num: 1, odcost: null };
      this.addPriceDialogVisible = false;
    },

    // 通用的加载编辑/查看数据逻辑
    async loadCategoryDetail(id, isView = false) {
      this.dynamicTitle = isView ? '查看' : '编辑';
      this.isLookData = isView;
      this.selectedRow = null;
      this.tableData2 = [];
      this.selectedValues = [];

      const res = await getCategory({ regTyped: id });
      if (res.code === 200) {
        await this.handleSelectionChange();
        await this.loadItemPriceOptions();
        this.selectedValues = res.data.profttlVOS.map(item => item.id);
        this.tableData2 = res.data.costnametableVOS;
        this.editTimeRange = [
          res.data.starttime || dayjs().startOf('day').format('HH:mm:ss'),
          res.data.endtime || dayjs().endOf('day').format('HH:mm:ss')
        ];
        this.editForm = JSON.parse(JSON.stringify(res.data));
        this.editForm.status = parseInt(this.editForm.status);
        this.editForm.registertype = parseInt(this.editForm.registertype);
        this.editDialogVisible = true;
      }
    },

    async handleClickEdit(data) {
      await this.loadCategoryDetail(data.id, false);
    },
    async handledbRow(row) {
      await this.loadCategoryDetail(row.id, true);
    },

    // 提交编辑表单
    async submitForm() {
      try {
        await this.$refs.editFormRef.validate();
      } catch (error) {
        this.$message.error('请填写完整表单');
        return;
      }
      await this.editCategoryData();
    },

    // 新增挂号类别
    async addCategoryData() {
      await withLoading(this, '数据提交中...')(async () => {
        this.addForm.profttlIds = this.selectedValues;
        this.addForm.regJoinVOS = [...this.tableData2];

        if (!this.addForm.profttlIds?.length) {
          this.$message.error('请选择至少一个职称');
          return;
        }
        if (!this.addForm.regJoinVOS?.length) {
          this.$message.error('请添加至少一项费用');
          return;
        }

        const res = await addCategoryData(this.addForm);
        if (res.code === 200) {
          this.addForm = getEmptyAddForm();
          this.$refs.addFormRef?.resetFields();
          this.addDialogVisible = false;
          this.selectedValues = [];
          this.tableData2 = [];
          this.getCategoryOptions();
          await this.loadData();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    async getCategoryOptions() {
      const res = await getRegisterType();
      this.$store.commit('preload/updatePreloadData', {
        key: 'getCategoryOptions',
        data: res.data.map(item => ({
          id: item.id,
          label: item.designation,
          odcost: Number(item.odcost).toFixed(2),
          pycode: generatePinyinCode(item.designation),
        }))
      });
    },

    // 编辑挂号类别
    async editCategoryData() {
      await withLoading(this, '数据提交中...')(async () => {
        this.editForm.profttlIds = this.selectedValues;
        this.editForm.regJoinVOS = [...this.tableData2];

        if (!this.editForm.profttlIds?.length) {
          this.$message.error('请选择至少一个职称');
          return;
        }
        if (!this.editForm.regJoinVOS?.length) {
          this.$message.error('请添加至少一项费用');
          return;
        }
        if (this.editForm.startage > this.editForm.endage) {
          this.$message.error("年龄下限不能大于年龄上限");
          return;
        }

        const res = await editCategoryData(this.editForm);
        if (res.code === 200) {
          this.editForm = getEmptyEditForm();
          this.getCategoryOptions();
          this.editDialogVisible = false;
          await this.loadData();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 启用/禁用
    async handleStartOrDisabled(row) {
      const action = row.status === '1' ? '禁用' : '启用';
      try {
        await this.$confirm(`请确认是否${action}【${row.designation}】`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        await withLoading(this, `${action}处理中...`)(async () => {
          const rs = await getCategory({ regTyped: row.id });
          const editData = { ...row };
          editData.status = row.status === '1' ? '0' : '1';
          editData.profttlIds = rs.data.profttlVOS.map(item => item.id);
          editData.regJoinVOS = rs.data.costnametableVOS;
          const res = await editCategoryData(editData);
          if (res.code === 200) {
            this.getCategoryOptions();
            await this.loadData();
          } else {
            this.$message.error(res.message);
          }
        });
      } catch {
        // 用户取消操作，不做处理
      }
    },

    // 加载表格数据
    async loadData() {
      const res = await docregistertype({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.searchValue || '',
        status: this.pageDataState
      });
      if (res.code === 200) {
        this.tableData = res.data.content;
        this.pageNum = res.data.pageNum;
        this.pageSize = res.data.pageSize;
        this.totalSize = res.data.totalSize;
      } else {
        this.$message.error(res.message);
      }
    },

    handClick(i) {
      if (i === 0) {
        this.loadData();
      } else if (i === 1) {
        this.addDialogVisible = true;
        this.selectedRow = null;
        this.selectedValues = [];
        this.tableData2 = [];
      }
    },

    // 状态筛选
    handleCommand(command) {
      this.pageDataState = command === 'a' ? 1 : command === 'b' ? 0 : null;
      this.DropDownedName = command === 'a' ? '可用' : command === 'b' ? '禁用' : '全部';
      this.loadData();
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    // 表格列格式化
    formatColumn(row, prop) {
      const value = row[prop];
      switch (prop) {
        case 'costid':
          return this.mapToLabel(value, this.itemPriceOptions);
        case 'registertype':
          return this.mapToLabel(value, this.TypeOption);
        case 'status':
          return this.mapToLabel(value, this.statusOptions);
        default:
          return value;
      }
    },
    mapToLabel(value, options) {
      if (value === undefined || value === null) return '';
      const found = options.find(item => item.id == value);
      return found ? found.label : value;
    },
    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },

    // 表格宽度辅助
    getColumnWidth(label, prop, tableData) {
      if (!tableData || tableData.length === 0) return 120;
      const minWidth = 80;
      const padding = 30;
      const contentList = tableData.map(item => item?.[prop] ?? '');
      const widths = [...contentList, label].map(text => {
        return this.getTextWidth(String(text || '')) + padding;
      });
      return Math.max(minWidth, ...widths);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, { column }) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", { class: "table-head", style: "width:100%" }, [column.label]);
    }
  }
}
</script>

<style lang="less" scoped>
/* 下拉菜单样式 */
.status-dropdown .el-dropdown-menu__item {
  font-size: 12px !important;
  color: #606266 !important;
}

.status-dropdown .el-dropdown-menu__item:hover {
  color: #409EFF !important;
  background-color: #f5f7fa !important;
}
/* 价格表单居中样式 */
.price-form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
}

.center-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.center-form .el-form-item {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.center-form .el-form-item:last-child {
  margin-bottom: 0;
}

.center-form .el-form-item__label {
  width: 80px;
  text-align: right;
  padding-right: 10px;
  justify-content: flex-end;
}

.center-form .el-form-item__content {
  flex: 1;
  display: flex;
  justify-content: center;
}

/* 或者使用更简单的居中方式 */
.price-form-container .compact-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.price-form-container .el-form-item {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
}

.price-form-container .el-form-item__label {
  width: 80px;
  text-align: right;
  padding-right: 10px;
}

.price-form-container .el-form-item__content {
  width: 180px;
}
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px;
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px);
  margin: 0 auto;
}

.el-dialog {
  min-width: 400px;

  .el-dialog__body {
    padding: 10px 15px !important;
  }

  @media (max-width: 768px) {
    width: 90% !important;
    min-width: unset;
  }
}

.compact-form {
  .el-form-item {
    margin-bottom: 6px !important;
  }

  .el-row {
    margin-bottom: -5px !important;

    .el-col {
      padding-bottom: 5px !important;
    }
  }

  .multi-select-container {
    margin: 4px 0 8px !important;

    .select-row {
      margin-bottom: 2px !important;

      .selected-tags {
        margin-top: 2px !important;

        .el-tag {
          margin: 0 4px 2px 0 !important;
        }
      }
    }
  }

  .table-header {
    margin: 4px 0 6px !important;
  }

  .el-table {
    margin-top: 5px !important;

    th, td {
      padding: 3px 0 !important;
    }
  }
}

.dialog-footer {
  padding: 8px 15px !important;
}

.multi-select-container {
  padding: 20px;
}

.select-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.select-label {
  font-size: 14px;
  color: #606266;
  margin-right: 10px;
  white-space: nowrap;
  flex-shrink: 0;
}

.select-with-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
}

.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-left: 10px;
}

.el-select {
  width: 150px;
}

.el-tag {
  margin-right: 6px;
}

.transparent-btn-group {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.transparent-btn {
  background-color: transparent !important;
  border: none !important;
  color: white !important;
  padding: 6px 8px !important;
  font-size: 14px !important;
}

.table-header {
  background-color: #39648f;
  color: white;
  padding: 3px 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px 4px 0 0;
}

.el-table :deep(.current-row) {
  background-color: #000 !important;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn {
  top: 12px;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-dialog__header {
  background-color: #39648f;
  padding: 8px;
}

/deep/ .el-dialog__body {
  padding: 0 20px 0 20px;
  border: 1px solid #efefef;
  padding: 8px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-table .cell {
  font-size: 12px;
  text-align: center;
}

.MedicenCata {
  height: 100%;
  width: 100%;

  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;

      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-b {
          margin-left: 28px;
        }

        .main-icon-c {
          display: flex;
          margin-left: 28px;
        }
      }

      .table {
        padding: 0 12px;
      }
    }
  }
}
</style>